<template>
  <div class="ba-flex ba-flex-col ba-items-center ba-m-auto ba-p-4 ba-w-full">
    <figure v-if="logo" href="/" class="identity__logo ba-text-center ba-w-full ba-max-w-76">
      <img class="ba-mb-4 ba-w-full ba-inline" src="/img/brand/white/logo.svg" alt="Logo" />
    </figure>
    <div class="splash-screen__msg ba-w-full ba-text-center">
      <span class="far fa-exclamation-circle" :class="sizeClass" />
      <div v-if="hasDefaultSlot" class="ba-mt-2">
        <slot></slot>
      </div>
      <div class="ba-mt-2 ba-flex ba-flex-col ba-text-center" v-if="withDefault">
        <div class="ba-mb-2">Ошибка при получении данных</div>
        <a
          v-if="backToHome"
          :href="getErrorBackUrl(state)"
          class="ba-text-link ba-underline hover:ba-no-underline"
        >Вернуться на главную</a>
      </div>
    </div>
  </div>
</template>

<script>
import { errorUtilMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-error",
  mixins: [errorUtilMixin],
  props: {
    logo: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "",
      validator: (v) => ["xs", "sm", "md", "lg", ""].indexOf(v) !== -1
    },
    withDefault: {
      type: Boolean,
      default: false
    },
    backToHome: {
      type: Boolean,
      default: true
    },
    state: {
      type: String,
      default: undefined
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case "lg":
          return "ba-text-6xl";
        case "sm":
          return "ba-text-3xl";
        case "xs":
          return "ba-text-xl";
        case "md":
          return "ba-text-5xl";
        default:
          return "";
      }
    },
    hasDefaultSlot() {
      return !!this.$slots.default;
    }
  }
};
</script>
